import styled from 'styled-components';

import PrimitiveWeekDays from '../../../../../../newComponents/WeekDays';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #101d40;
  }

  p {
    color: #7c8db5;
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const Options = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  row-gap: 20px;
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 7px;

  strong {
    color: #101d40;
    margin-bottom: 5px;
    font-weight: 500;
  }

  span {
    color: #a6a6a6;
  }

  strong,
  span {
    font-size: 14px;
  }
`;

export const WeekDaysAvailabilityContainer = styled.div`
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 5px;
  margin-top: 20px;

  h3 {
    font-size: 16px;
    color: #101d40;
    font-weight: 600;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const WeekDays = styled(PrimitiveWeekDays)`
  justify-content: flex-start;
  margin: 20px 0px 18px;
`;

export const ShiftsRange = styled.div`
  width: 100%;
  max-width: 410px;

  div.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    h4 {
      font-size: 14px;
      color: #101d40;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      color: #329bfc;
      font-weight: 500;
      cursor: pointer;

      svg {
        margin-bottom: -2px;
        margin-right: 3px;
      }

      &:hover {
        span {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const ShiftRange = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  div.details {
    display: flex;
    align-items: center;
    flex: 1;

    h5 {
      font-size: 14px;
      color: #101d40;
      font-weight: 600;
    }

    div.selects {
      display: flex;
      align-items: center;
      margin-left: auto;

      select {
        height: 38px;
        width: 90px;
        border: 2px solid #e6effb;
        border-radius: 5px;
        padding: 0px 8px;
        color: #101d40;
        font-family: 'Sora';
        font-size: 14px;
        font-weight: 500;
        transition: all 0.2s ease;

        &:hover:not(:focus) {
          border-color: #96cdff;
        }

        &:focus {
          border-color: #329bfc;
        }

        @media only screen and (max-width: 530px) {
          width: 85px;
        }
      }

      > span {
        color: #329bfc;
        font-size: 14px;
        font-weight: 600;
        margin: 0px 10px;
      }
    }

    @media only screen and (max-width: 530px) {
      justify-content: space-between;
      width: 100%;
    }
  }

  button {
    width: 38px;
    height: 38px;
    border-radius: 5px;
    border: none;
    outline: none;
    background-color: rgba(246, 68, 68, 0.1);
    margin-left: 20px;

    span {
      color: #f64444;
      font-size: 24px;
    }

    &:hover {
      background-color: rgba(246, 68, 68, 0.2);
    }

    @media only screen and (max-width: 530px) {
      width: 100%;
      margin: 10px 0 0;
    }
  }

  & + div {
    margin-top: 16px;
  }

  @media only screen and (max-width: 530px) {
    flex-direction: column;
  }
`;
